(function () {
    'use strict';
    /*
     * Copyright (c) 2014-16 In Hand Health.
     * All rights reserved.
     */

    /**
     * A controller that must be attached to a parent element of the ng-view element for projects that use its services. See below
     * for an example of how this might be done.
     * @ngdoc controller
     * @memberOf ihh-common-web
     * @name MainCtrl
     * @example
     *     <body ng-controller="MainCtrl">
     *       <div class="container-fluid">
     *           <div ng-include="'/navbar.html'"></div>
     *           <div ng-view="" ng-show="allowed"></div>
     *           <div ng-include="'/footer.html'"></div>
     *       </div>
     *     </body>
     * @property allowed {Boolean} A flag for whether the single page app content should be shown; becomes true when the user is logged in and not on the login page or some other page that precludes regulare SPA content.
     * @property print {Boolean} A flag for whether the page is being rendered for printing
     *
     */
    angular
        .module('ihh-common-web')
        .controller('MainCtrl', MainCtrl);

    MainCtrl.$inject = ['$scope', '$location', '$route', '$window', '$modalStack', '$modal', '$log', '$sce', 'LoginSvc', 'RestResources', 'Utilities', 'MemorySvc', 'AUTH_EVENTS', 'UserSvc', 'Idle', 'Title', 'AppConfigSvc', '_'];

    function MainCtrl($scope, $location, $route, $window, $modalStack, $modal, $log, $sce, LoginSvc, RestResources, Utilities, MemorySvc, AUTH_EVENTS, UserSvc, Idle, Title, AppConfigSvc, _) {
        /**
         * Sends a request to the server to make sure we are still connected. An expected side effect is that the server will renew the
         * session if it is soon expiring. The returned session expiration is stored, as well as server role information.
         */
        var pingServer = function () {
            if ($scope.user.session) {
                RestResources.getSessionResource().get(angular.extend({
                    id: $scope.user.session.id
                }, AppConfigSvc.getLoginParams()), function (resultSession) {
                    if (UserSvc.update($scope.user, resultSession)) {
                        $location.path('/');
                    }
                }, function (/* err */) {
                    LoginSvc.logout();
                });
            }
        };

        $scope.angular = angular; // so we can get at the helper functions without wrapping each separately
        $scope.allowed = false;

        $scope.print = false;

        /**
         * Sets the page to print mode.
         * @ngdoc method
         * @name setPrint
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.setPrint = function (value) {
            $scope.print = value;
        };

        $scope.$on(AUTH_EVENTS.forbidden, function () {
            //            $modalStack.dismissAll();
            //            $scope.user = UserSvc.destroy($scope.user);
            //            if ($location.path() !== '/login') {
            //                $location.path('/login');
            //            }
        });

        $scope.$on(AUTH_EVENTS.notAuthorized, function () {
            $modalStack.dismissAll();
            $scope.user = UserSvc.destroy($scope.user);
            if ($location.path() !== '/login') {
                $location.path('/login');
            }
        });

        $scope.$on(AUTH_EVENTS.loginSuccess, function (event, session) {
            $scope.user = UserSvc.create(session);
            Title.original(AppConfigSvc.getTitle());
            Title.restore();
            Idle.watch();
        });

        $scope.$on(AUTH_EVENTS.logout, function ( /*event, session*/) {
            $modalStack.dismissAll();
            $scope.user = UserSvc.destroy($scope.user);
            Idle.unwatch();
            $location.path('/login');
        });

        $scope.$on('IdleStart', function () {
            $log.debug('started idling...');
            // the user appears to have gone idle
        });

        $scope.$on('IdleWarn', function ( /*e, countdown*/) {
            $log.debug('warning idler...');
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
        });

        $scope.$on('IdleTimeout', function () {
            $log.debug('idled too long!');
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            $scope.logout();
        });

        $scope.$on('IdleEnd', function () {
            $log.debug('stopped idling...');

            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
        });

        $scope.$on('Keepalive', function () {
            $log.debug('keep on keepin on!');

            // do something to keep the user's session alive
            pingServer();
        });

        $scope.user = UserSvc.init();

        /**
         * Returns whether the app is the operations app.
         * @ngdoc method
         * @name isOpsApp
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.isOpsApp = function () {
            return AppConfigSvc.isOpsApp();
        };

        /**
         * Returns whether the app is the patient app.
         * @ngdoc method
         * @name isPatientApp
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.isPatientApp = function () {
            return AppConfigSvc.isPatientApp();
        };

        /**
         * Returns whether the app is the clinic app.
         * @ngdoc method
         * @name isClinicApp
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.isClinicApp = function () {
            return AppConfigSvc.isClinicApp();
        };

        /**
         * Returns the current session object.
         * @ngdoc method
         * @name getSession
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.getSession = function () {
            return $scope.user.session;
        };

        /**
         * Returns the current user object.
         * @ngdoc method
         * @name getSelf
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.getSelf = function () {
            return $scope.user.self;
        };

        /**
         * Returns the current clinic object, if in an app that supports it
         * @ngdoc method
         * @name getClinic
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.getClinic = function () {
            return $scope.user.clinic;
        };

        /**
         * Refreshes the user associated with the session, from the server.
         * @ngdoc method
         * @name refreshSelf
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.refreshSelf = function () {
            if ($scope.user.session) {
                RestResources.getSelfResource($scope.user.self.id).get(function (self) {
                    if (self.id && angular.isArray(self.images)) {
                        var index = self.images.indexOf('thumbnail');
                        if (index >= 0) {
                            self.thumbnailUrl = RestResources.getUserThumbnailUrl(self);
                        }
                    }
                    var oldSelf = $scope.user.self;
                    self.clinicProfessionals = oldSelf.clinicProfessionals;
                    self.ihhProfessional = oldSelf.ihhProfessional;
                    $scope.user.setSelf(self);
                });
            }
        };

        /**
         * Returns whether the user is logged in.
         * @ngdoc method
         * @name isLoggedIn
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.isLoggedIn = function () {
            return UserSvc.isLoggedIn($scope.user);
        };

        /**
         * Sets the user's clinic, in apps that support it.
         * @ngdoc method
         * @name setClinic
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.setClinic = function (clinic) {
            var proRel = $scope.getClinicProfessional(clinic);
            proRel.person = angular.copy($scope.user.self);
            $scope.user.setClinic(proRel.clinic);
            $scope.user.setClinicProfessional(proRel);
            $scope.user.setRoles(proRel && proRel.clinic ? proRel.roles : []);
            $scope.user.setPermissions(proRel && proRel.clinic ? proRel.permissions : []);

            MemorySvc.memorize(MemorySvc.LOCAL, UserSvc.LAST_CLINIC_ID, proRel.clinic.id);

            // All kinds of things might have changed because of changing clinic.  Just do a big ol' reload, but in a timeout
            // to make sure everything is settled down first.
            $window.location.href = '/';
        };

        $scope.getClinicProfessional = function (clinic) {
            var pro = null;
            if (angular.isArray($scope.user.clinicProfessionals)) {
                for (var i = 0; i < $scope.user.clinicProfessionals.length; i++) {
                    var clinicProfessional = $scope.user.clinicProfessionals[i];
                    if (clinicProfessional.clinic.id === clinic.id) {
                        pro = clinicProfessional;
                        break;
                    }
                }
            }
            return pro;
        };

        /**
         * Logs the user out of the application.
         * @ngdoc method
         * @name logout
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.logout = function () {
            LoginSvc.logout($scope.user.session);
        };

        /**
         * Moves the user back one page in his history.
         * @ngdoc method
         * @name back
         * @memberOf ihh-common-web.MainCtrl
         */
        $scope.back = function () {
            Utilities.back();
        };

        /**
         * Allows callers (such as controllers on nested scopes) to stash values that
         * persist as long as this main controller lives. It is up to callers to cooperatively
         * create a key namespace that avoids collisions.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name putValue
         * @param {String} key the key to store the value
         * @param {Object} value the stored value
         */
        $scope.putValue = function (key, value) {
            MemorySvc.memorize(MemorySvc.JS, key, value);
        };

        /**
         * Returns a value previously stored by a call to putValue().
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getValue
         * @param {String} key the key used to store the value
         * @returns {Object} the stored value or undefined
         */
        $scope.getValue = function (key) {
            return MemorySvc.recall(MemorySvc.JS, key);
        };

        /**
         * Returns whether the user has at least one context-defined role.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name hasRoles
         * @returns {Boolean} true if the user has roles
         */
        $scope.hasRoles = function () {
            return UserSvc.hasRoles($scope.user);
        };

        /**
         * Returns whether the user has an IHH log reader role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isIhhLogReader
         * @returns {Boolean} true if the user has an IHH log reader role
         */
        $scope.isIhhLogReader = function () {
            return UserSvc.isIhhLogReader($scope.user);
        };

        /**
         * Returns whether the user has an IHH admin role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isIhhAdmin
         * @returns {Boolean} true if the user has an IHH admin role
         */
        $scope.isIhhAdmin = function () {
            return UserSvc.isIhhAdmin($scope.user);
        };

        /**
         * Returns whether the user has an IHH content manager role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isIhhContentManager
         * @returns {Boolean} true if the user has an IHH content manager role
         */
        $scope.isIhhContentManager = function () {
            return UserSvc.isIhhContentManager($scope.user);
        };

        /**
         * Returns whether the user has an IHH accounting manager role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isIhhAccountingManager
         * @returns {Boolean} true if the user has an IHH accounting manager role
         */
        $scope.isIhhAccountingManager = function () {
            return UserSvc.isIhhAccountingManager($scope.user);
        };

        /**
         * Returns whether the user has an IHH sales manager, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isIhhSalesManager
         * @returns {Boolean} true if the user has an IHH sales manager role
         */
        $scope.isIhhSalesManager = function () {
            return UserSvc.isIhhSalesManager($scope.user);
        };

        /**
         * Returns whether the user has a clinic admin role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isClinicAdmin
         * @returns {Boolean} true if the user has a clinic admin role
         */
        $scope.isClinicAdmin = function () {
            return UserSvc.isClinicAdmin($scope.user);
        };

        /**
         * Returns whether the user has a clinic admin role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isPatientAdmin
         * @returns {Boolean} true if the user has a patient admin role
         */
        $scope.isPatientAdmin = function () {
            return UserSvc.isPatientAdmin($scope.user);
        };

        /**
         * Returns whether the user has a clinic therapist role, in those apps that support it.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name isTherapist
         * @returns {Boolean} true if the user has a therapist role
         */
        $scope.isTherapist = function () {
            return UserSvc.isTherapist($scope.user);
        };

        /**
         * Returns whether the user is a staff communicator, i.e. can send clinical messages.
         * @returns {Boolean} true if the user has a staff communicator role
         */
        $scope.isStaffCommunicator = function () {
            return UserSvc.isStaffCommunicator($scope.user);
        };

        /**
         * Returns whether the user is an associate, i.e. eligible to be added as an associate by other clinics.
         * @returns {Boolean} true if the user has an associate role
         */
        $scope.isAssociate = function () {
            return UserSvc.isAssociate($scope.user);
        };

        /**
         * Returns whether the user has a particular permission
         * @param {String} permission
         * @returns {Boolean} true if the user has the permission; false otherwise
         */
        $scope.hasPermission = function (permission) {
            return UserSvc.hasPermission($scope.user, permission);
        };

        /**
         * Returns whether the current clinic has a particular feature flag
         * @param {String} feature the feature to check for
         * @returns {Boolean} true if the current clinic has the feature; false otherwise
         */
        $scope.hasClinicFeature = function (feature) {
            var clinic = $scope.user.clinic;
            var result = !!_.find(clinic.featureFlags, function (ff) {
                return ff === feature;
            });

            return result;
        };

        if ($scope.isLoggedIn()) {
            $scope.refreshSelf();
        }
        else if (!($location.path() === '/login' || $location.path().slice(0, '/login'.length) === '/login')) {
            $location.path('/login');
        }

        $scope.$on('$locationChangeStart', function (event, next) {
            if (!$scope.isLoggedIn() && next.slice(next.indexOf('#') + 1, next.indexOf('#') + 1 + '/login'.length) !== '/login') {
                event.preventDefault();
                $location.path('/login');
            }
        });

        if ($scope.isLoggedIn() || ($location.path() === '/login' || $location.path().slice(0, '/login'.length) === '/login')) {
            $scope.allowed = true;
        }

        if ($scope.deregister) {
            $scope.deregister();
            $scope.deleteFromRoot('deregister');
        }

        $scope.getResourceMaterialThumbnailUrl = function (resource) {
            return RestResources.getResourceMaterialThumbnailUrl(resource);
        };

        $scope.getResourceMaterialMediaUrl = function (resource) {
            return RestResources.getResourceMaterialMediaUrl(resource);
        };

        /**
         * Returns a thumbnail URL for a clinic.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getClinicThumbnailUrl
         * @param {Object} clinic the clinic to get the thumbnail for
         * @returns {String} a thumbnail URL for the clinic
         */
        $scope.getClinicThumbnailUrl = function (clinic) {
            var thumb = $scope.getDefaultClinicThumbnailUrl();
            if (clinic && clinic.id && clinic.thumbnail) {
                thumb = RestResources.getImageUrl('clinics', clinic.id, clinic.thumbnail);
            }

            return thumb;
        };

        /**
         * Returns a thumbnail URL for a user.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getUserThumbnailUrl
         * @param {Object} user the user to get the thumbnail for
         * @returns {String} a thumbnail URL for the user
         */
        $scope.getUserThumbnailUrl = function (user) {
            var thumb = $scope.getDefaultPersonThumbnailUrl();
            var userThumbnail;
            var personThumbnail;

            if (Utilities.isDefinedAndNotNull(user)) {
                userThumbnail = user.thumbnailUrl;
                if (Utilities.isDefinedAndNotNull(user.person)) {
                    personThumbnail = user.person.thumbnailUrl;
                }

                if (Utilities.isDefinedAndNotNull(userThumbnail)) {
                    thumb = userThumbnail;
                }
                else if (Utilities.isDefinedAndNotNull(personThumbnail)) {
                    thumb = personThumbnail;
                }
            }

            return RestResources.appendMediaParams(thumb);
        };

        /**
         * Returns a thumbnail URL for a patient.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getPatientThumbnailUrl
         * @param {Object} patient the patient to get the thumbnail for
         * @returns {String} a thumbnail URL for the patient
         */
        $scope.getPatientThumbnailUrl = function (clinic, patient) {
            var thumb = $scope.getDefaultPersonThumbnailUrl();
            if (patient) {
                thumb = $scope.getUserThumbnailUrl(patient);
            }

            return thumb;
        };

        /**
         * Returns a thumbnail URL for a clinic staff person.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getClinicStaffThumbnailUrl
         * @param {Object} clinicStaff the clinic staff person to get the thumbnail for
         * @returns {String} a thumbnail URL for the clinic staff person
         */
        $scope.getClinicStaffThumbnailUrl = function (clinic, clinicStaff) {
            var thumb = $scope.getDefaultPersonThumbnailUrl();
            if (clinic && clinicStaff) {
                if (clinicStaff && clinicStaff.thumbnail) {
                    thumb = RestResources.getClinicStaffImageUrl(clinic.id, clinicStaff.id, clinicStaff.thumbnail);
                }
                else {
                    thumb = $scope.getUserThumbnailUrl(clinicStaff);
                }
            }

            return thumb;
        };

        /**
         * Returns a thumbnail URL for an In Hand Health staff person.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getIhhStaffThumbnailUrl
         * @param {Object} staff the In Hand Healt hstaff person to get the thumbnail for
         * @returns {String} a thumbnail URL for the In Hand Health staff person
         */
        $scope.getIhhStaffThumbnailUrl = function (staff) {
            var thumb = $scope.getDefaultPersonThumbnailUrl();
            if (staff) {
                if (staff.ihhRelationship && staff.ihhRelationship.thumbnail) {
                    thumb = RestResources.getIhhStaffImageUrl(staff.id, staff.ihhRelationship.thumbnail);
                }
                else {
                    thumb = $scope.getUserThumbnailUrl(staff);
                }
            }

            return thumb;
        };


        /**
         * Returns a thumbnail URL for an exercise.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getExerciseThumbnailUrl
         * @param {Object} exercise the exercise to get the thumbnail for
         * @returns {String} a thumbnail URL for the exercise
         */
        $scope.getExerciseThumbnailUrl = function (exercise) {
            return RestResources.getExerciseThumbnailUrl(exercise);
        };

        /**
         * Returns a URL for an exercise still.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getExerciseStillUrl
         * @param {Object} exercise the exercise to get the still for
         * @param {String} name the name of the still to get the URL for
         * @returns {String} a URL for the exercise still
         */
        $scope.getExerciseStillUrl = function (exercise, name) {
            return RestResources.getExerciseImageUrl(exercise, name);
        };

        /**
         * Returns a URL for an exercise video.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getExerciseVideoUrl
         * @param {Object} exercise the exercise to get the video for
         * @param {String} name the name of the video to get the URL for
         * @returns {String} a URL for the exercise video
         */
        $scope.getExerciseVideoUrl = function (exercise, name) {
            return RestResources.getExerciseVideoUrl(exercise, name);
        };

        $scope.getResourceMaterialVideoUrl = function (resource, name) {
            return RestResources.getResourceMaterialMediaUrl(resource, name);
        };

        $scope.allowMedia = function (mediaUrl) {
            return $sce.trustAsResourceUrl(mediaUrl);
        };

        $scope.terms = AppConfigSvc.getTerms();
        $scope.version = AppConfigSvc.getBuildVersion();
        $scope.restVersion = RestResources.getRestVersionResource().get();
        $scope.currentYear = new Date().getFullYear(); // used mostly by the footer copyright year display

        $scope.showVersion = function () {
            $modal.open({
                templateUrl: 'utilities/modal-about.tpl.html',
                controller: 'ModalAboutCtrl',
                scope: $scope
            });
        };

        $scope.getCommonHost = function () {
            return RestResources.getCommonHost();
        };

        $scope.getDefaultExerciseThumbnailUrl = function () {
            return RestResources.getDefaultExerciseThumbnailUrl();
        };

        $scope.getDefaultVideoThumbnailUrl = function () {
            return RestResources.getDefaultVideoThumbnailUrl();
        };

        $scope.getDefaultClinicThumbnailUrl = function () {
            return RestResources.getDefaultClinicThumbnailUrl();
        };

        $scope.getDefaultPersonThumbnailUrl = function () {
            return RestResources.getDefaultPersonThumbnailUrl();
        };

        $scope.getDefaultPatientThumbnailUrl = function () {
            return RestResources.getDefaultPatientThumbnailUrl();
        };

        $scope.getDefaultIhhStaffThumbnailUrl = function () {
            return RestResources.getDefaultIhhStaffThumbnailUrl();
        };

        $scope.getDefaultTherapistThumbnailUrl = function () {
            return RestResources.getDefaultTherapistThumbnailUrl();
        };

        $scope.getDefaultResourceMaterialThumbnailUrl = function () {
            return RestResources.getDefaultResourceMaterialThumbnailUrl();
        };

        $scope.getSafeUrl = function (url) {
            return RestResources.getSafeUrl(url);
        };

        /**
         * Returns the approrpriate name of the login image.
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getLogoUrl
         * @returns {String} the approrpriate logo filename
         */
        $scope.getLogoUrl = function () {
            if ($scope.isPatientApp()) {
                return '';
            }

            var baseUrl = $scope.getCommonHost() + '/assets/';
            var host = $location.host().toLowerCase();

            if (_.startsWith(host, 'greatlakes.') || _.startsWith(host, 'greatlakes-dot-')) {
                return baseUrl + 'greatlakes-logo-login.png';
            }

            if (_.startsWith(host, 'ezclear.') || _.startsWith(host, 'ezclear-dot-')) {
                return baseUrl + 'ezclear-logo-login.png';
            }

            if (_.startsWith(host, 'fivestarortho.') || _.startsWith(host, 'fivestarortho-dot-')) {
                return baseUrl + 'fivestarortho-logo-login.png';
            }

            if (_.startsWith(host, 'toothpillow.') || _.startsWith(host, 'toothpillow-dot-')) {
                return baseUrl + 'toothpillow-logo-login.png';
            }

            return baseUrl + 'ihh-ptih-logo-login.png';
        };

        /*
         * Makes the app-specific config available on the main scope so it can be accessed anywhere, even when there is not
         * another controller.
         */
        $scope.getAppConfig = function () {
            return AppConfigSvc.getAppConfig();
        };

        /**
         * Returns the appropriate app name for the welcome text
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getLoginText
         * @returns {String} welcome text app name
         */
        $scope.getLoginText = function () {
            if (AppConfigSvc.isOpsApp()) {
                return 'the In Hand Health OPS Console';
            }
            else if (AppConfigSvc.isClinicApp()) {
                return 'the Console';
            }
            else if (AppConfigSvc.isPatientApp) {
                return 'the Client Console';
            }

            return 'In Hand Health';
        };

        /**
         * Returns the appropriate help url
         * @ngdoc method
         * @memberOf ihh-common-web.MainCtrl
         * @name getHelpUrl
         * @returns {String} the help url
         */
        $scope.getHelpUrl = function () {
            var defaultUrl = 'https://inhandhealth.zendesk.com/hc/en-us/requests/new';

            return defaultUrl;
        };

        // Setup a value on scope so that various components can verify that the screen meets the specified minimum resolution
        $scope.lowResolution = $window.innerWidth < AppConfigSvc.getMinWidth();
    }
})();
